import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";
import { useFulfillmentGroupAdjustments } from "../../utils/use-group-info";
import { ShipmentAdjustmentText } from "../fulfillment-group-slideout/shipment-adjustments-section";

function ShipmentAdjustmentsCell({ row }: { row: FulfillmentGroupData }) {
  const adjustments = useFulfillmentGroupAdjustments([row]);

  if (adjustments.length === 0) {
    return null;
  }

  if (adjustments.length === 1 && adjustments[0]) {
    return (
      <RedoTablePaddedCell>
        <ShipmentAdjustmentText adjustment={adjustments[0]} />
      </RedoTablePaddedCell>
    );
  }

  return (
    <RedoTablePaddedCell>
      <Text fontSize="xs" textColor="secondary">
        {adjustments.length} adjustments
      </Text>
    </RedoTablePaddedCell>
  );
}

export const ShipmentAdjustmentsColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: fgColumnEntries.shipmentAdjustments.key,
  title: fgColumnEntries.shipmentAdjustments.title,
  renderNormalCell: ({ row }) => <ShipmentAdjustmentsCell row={row} />,
  width: fgColumnEntries.shipmentAdjustments.defaultWidth,
};
